<template>
  <div class="jump-order nav-bar-fixed">
    <van-nav-bar title="订单详情" left-arrow fixed @click-left="back" />
    <div class="order-cell-item">
      <van-row class="jump-order-item" type="flex" v-for="item in order.carts">
        <van-col span="10" class="jump-order-item-img">
          <img :src="item.imges" />
        </van-col>
        <van-col span="14" class="jump-order-item-warp">
          <p>{{item.goodsName}}</p>
           <p>
            <span>销售单位：</span>
            {{item.goodsUnit}}
          </p>
          <p>
            <span>商品数量：</span>
            {{item.count}}
          </p>
          <p>
            <span>积分：</span>
            {{item.integral}}分
          </p>
        </van-col>
      </van-row>
     
    </div>

    <div class="order-cell-item order-info">
      <h5>订单信息</h5>
      <van-cell title="订单编号" :value="order.igoOrderSn" />
      <van-cell title="创建时间" :value="order.createtime" />
      <van-cell title="付款时间" :value="order.igoPayTime" />
    </div>

     <div class="order-cell-item order-info">
      <h5>会员信息</h5>
      <van-cell title="会员名称" :value="order.userName" />
      <van-cell title="真实姓名" :value="order.receiveTrueName" />
      <van-cell title="会员Email" :value="order.email" />
      <van-cell title="牧场名称" :value="order.mcmc" />
      <van-cell title="牧场编号" :value="order.pastureID" />
      <van-cell title="用户类型" :value="order.userType" />
      <van-cell title="手机号" :value="order.mobile" />
      <van-cell title="所属分公司" :value="order.orgName" />
      <van-cell title="所属片区" :value="order.orgAreaName" />
      <van-cell title="所属业务员" :value="order.bussTrueName" />
      <van-cell title="所在地" :value="order.areaPath" />
    </div>
    <div class="order-cell-item order-info">
      <h5>收货地址</h5>
      <van-cell title="收货人" :value="order.receiveTrueName" />
      <van-cell title="所在地区" :value="order.receiveAreaPath" />
       <van-cell title="邮政编码" :value="order.receiveZip" />
      <van-cell title="详细地址" :value="order.receiveAreaInfo" />
      <van-cell title="手机号码" :value="order.receiveMobile" />
       <van-field label="留言" type="textarea" v-model="order.igoMsg" :readonly="true"/>
    </div>
    <div class="order-cell-item order-info">
        <h5>商品信息</h5>
       <van-cell title="本次消耗积分" :value="order.igoTotalIntegral" />
      <van-cell title="支付方式" :value="order.igoPayment" />
      <van-cell title="订单状态" :value="order.igoStatusName" />
      <van-cell title="审核备注" v-if="order.igoStatus == 26">
        <p>{{order.auditRemark}}</p>
      </van-cell>
    </div>
    <div class="order-cell-item order-info" v-if="order.auditMobile!=''&&order.auditMobile!=null">
        <h5>业务人员联系方式</h5>
       <van-cell title="手机号" :value="order.auditMobile" />
     
    </div>
  </div>
</template>
<script>
import { NavBar, Row, Col, Button, Cell ,Field} from "vant";

export default {
  name: "userIntegralOrderDetail",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Field.name]: Field,
  },
  data() {
    return {
      id: this.$route.query.id,
      order: {},
      orderInfo: {}
    };
  },
  mounted: function() {
    let that = this;
    that.seachOrderByid();
  },
  methods: {
    back() {
      history.back();
    },
    seachOrderByid() {
      let that = this;
      that.$api.post(
        that.jumuc.integral.orderDetail,
        { id: that.id },
        successRes => {
          that.order = successRes.data;
          that.orderInfo = that.order.orderInfo;
        }
      );
    }
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;
body {
  background-color: #f7f7f7;
}

.jump-order {
  padding-bottom: 60px;

  .order-cell-item {
    background-color: #fff;
    padding: 10px 15px;
    margin-bottom: 15px;
  }
  .order-state {
    color: @bule-thame;
    font-size: 16px;
    padding: 10px 15px;
    background-color: #fff;
  }
  .order-address-cell {
    margin-bottom: 15px;
  }
  .order-address-item {
    border-top: 1px solid #ebedf0;
    padding: 10px 15px;
    background-color: #fff;
    h5 {
      padding-top: 5px;
      font-size: 16px;
      color: @bule-thame;
    }
    p {
      color: #666;
      font-size: 14px;
    }
    i {
      height: 45px;
      width: 45px;
      line-height: 45px;
      display: inline-block;
      color: #fff;
      background-color: @bule-thame;
      font-size: 20px;
      border-radius: 100%;
    }
  }

  &-item {
    background-color: #fff;
    margin-bottom: 15px;
    align-items: center;
    border-radius: 20px;
    padding: 15px;
    position: relative;
    .van-checkbox {
      height: 100%;
      line-height: 100%;
    }
    &-img {
      img {
        width: 90%;
      }
    }

    h4 {
      font-size: 16px;
      padding: 10px 0;
    }
    &-warp {
      align-self: flex-start;
    }
    p {
      font-size: 14px;
      &.item-time {
        font-size: 14px;
        span {
          float: right;
          color: @bule-thame;
        }
        span.order-cancel {
          color: green;
        }
      }
      &.item-price {
        font-size: 16px;
        text-align: right;
      }
    }
    button {
      float: right;
      margin-top: 10px;
      border-radius: 25%;
    }
  }

  .order-info {
    h5 {
      font-size: 16px;
      color: @bule-thame;
      padding: 10px 0 20px;
    }
    .van-cell__title {
      flex: none;
      min-width: 90px;
    }
    .van-cell__value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }
    .order-copy {
      color: @bule-thame;
    }
  }

  .order-fre {
    .van-cell__value {
      color: red;
    }
  }

  .van-cell:not(:last-child)::after {
    border-width: 0;
  }
}

.navbar-foot {
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 55px;
  padding: 5px 0 0;
  border-top: 1px solid #f7f7f7;
  .nav-icon {
    text-align: center;
    font-size: 10px;
    i {
      font-size: 20px;
    }
  }
  .nav-warp {
    padding: 10px 0;
    text-align: right;
    button {
      margin-right: 5px;
      color: #999;
      border-color: #999;
      border-radius: 15px;
      font-size: 12px;
      padding: 0 10px;
      &.van-button--info {
        color: @bule-thame;
        border-color: @bule-thame;
      }
    }
  }
}
</style>


